import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import PasswordAlertBox from './PasswordAlertBox';

const INITIAL_STATE = {
    email: "",
    password: "",
    givenName: "",
    familyName: ""
}


function NewPassword(props){
    const [state, setState] = useState(INITIAL_STATE)

    const validateForm = () => {
        if(state.password !== state.passwordConfirm &&
            state.givenName !== "" &&
            state.familyName !== ""){
            toast.error("Please ensure passwords match and First/Last names are entered")
        } else {
            if(props.onSubmit){
                props.onSubmit(state)
            }
        }
    }

    useEffect(() => {
        if(props.user && props.user.challengeParam){
            const { family_name, given_name } = props.user.challengeParam.userAttributes

            setState(prevState => ({
                ...prevState,
                familyName: family_name,
                givenName: given_name
            }))
        }
    }, [props])

    const { password, familyName, givenName, passwordConfirm } = state

    return <form>
        <div className="form-group">
            <input type="password" onChange={e => setState({...state, password: e.target.value})} className="form-control input-lg" placeholder="New Password" name="password" value={password} required="" />
        </div>

        <div className="form-group">
            <input type="password" onChange={e => setState({...state, passwordConfirm: e.target.value})} className="form-control input-lg" placeholder="Confirm Password" name="passwordConfirm" value={passwordConfirm} required="" />
            
        </div>
        <div className="form-group">
            <input type="text" onChange={e => setState({...state, givenName: e.target.value})} className="form-control input-lg" placeholder="First Name" name="givenName" value={givenName} required="" />
            
        </div>
        <div className="form-group">
            <input type="text" onChange={e => setState({...state, familyName: e.target.value})} className="form-control input-lg" placeholder="Last Name" name="familyName" value={familyName} required="" />
            
        </div>
        <div className="form-group">
            <button type="button" className="btn btn-success btn-lg btn-block" onClick={() => validateForm()}>
                Set Password
            </button>
        </div>
        <PasswordAlertBox password={password} /> 
    </form>
}

NewPassword.defaultProps = {
    onSubmit: false,
    user: false
}

export default NewPassword